<template>
	<div>
		<div class="">
			<div class="time-text">
				查看 {{venue.name || '-无场地-'}}<el-date-picker
                @change="changeSearchTime"
                value-format="yyyy-MM-dd"
      v-model="selectTime"
      type="date"
      placeholder="选择日期">
    </el-date-picker>的场地排期情况
			</div>
			<div class="tips">
				请选择您要使用的场地时间段，排课时每节课都会使用该场地的时间段；系统将自动查询上课当天场地的使用情况，若该场地不可用将排课失败。
			</div>
		</div>
		<div>
			<div class="wrapper">
				<div class="flex">
					<div class="left-time flex-col">
						<div class="time" v-for="(time,index) in timeList" :key="index">
							<span>{{time}}</span>
						</div>
					</div>
					<div class="right-list">
						<div :scroll-x="true" class="scroll-box">
							<div class="flex">
								<div class="flex-col apt-box" v-for="(info,index) in appointmentList" :key="index">
									<div class="title"> {{ info.device.name || ''}}</div>
									<div class="scheduling-wrap"
										:style="{'grid-template-rows': `repeat(${timeList.length - 1},40px)`}">
										<div class="apt-wrap" :style="{'grid-row-start':apt.s_row,'grid-row-end':apt.e_row}" 
										v-for="(apt,i) in info.data" :key="i" :class="{
												'check':changeKeys.includes(`${i}_${apt.e}_${info.device.id}`),
													'sale':![1,2].includes(apt.v) 
												}" @click="changeItem(apt,i,info.device)">
											<div >
												{{caseMap[apt.v]}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		
			
			<div v-if="!loading && appointmentList.length == 0">
				<div class="">
					选取日期查询排期
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		props:{
			venue:{
				type:Object,
				default: ()=>{return {}}
			}
		},
		data() {
			return {
				mindate:new Date().Format('yyyy-MM-dd'),
				searchTimeShow: false,
				searchTime: '',
				loading: false,
				appointmentList: [],
				timeList: [],
				timeData: [],
				changeKeys:[],
				day: '',
                selectTime: '',
				caseMap: {
				    0: "不开放",
				    1: "闲时",
				    2: "高峰",
				    3: "已约满",
				  },
			};
		},
		methods:{
			clear(){
				this.timeData = []
				this.changeKeys = []
				this.appointmentList = []
				this.timeList = []
			},
			changeSearchTime(v){
				this.day = v
				this.getDayAppointment()
			},
			openDeviceTime(){
				this.searchTimeShow = true
			},
			changeItem(item, i, device) {
			  let k = `${i}_${item.e}_${device.id}`;
			
			  if (this.changeKeys[0]) {
			    let did = this.changeKeys[0].split("_")[2];
			    if (did != device.id) {
			      this.$toast("不能跨场地排课");
			      return;
			    }
			  }
			
			  if (item.v == 1 || item.v == 2) {
			    let i = this.changeKeys.indexOf(k);
			    if (i == -1) {
			      item.device_name = device.name;
			      this.changeKeys.push(k);
			      this.timeData.push(item);
			    } else {
			      this.changeKeys.splice(i, 1);
			      this.timeData.splice(i, 1);
			    }
			  }
			},
			
			getChangeTime() {
			  let list = this.timeData.map((t) => {
			    return {
			      s: t.s + ":00",
			      e: t.e + ":00",
			      device_id: t.service.device_id,
			      device_name: t.device_name,
			    };
			  });
			
			  return list;
			},
			getDayAppointment() {
				let data = {
					venue_id: this.venue.id,
					start_time: this.day + " 00:00:00",
					end_time: this.day + " 23:59:59",
				}
				this.loading = true
				this.timeData = []
				this.changeKeys = []
				this.$get('/shared/deviceScheduling/queryMecDayInfo', data).then(res => {
					this.loading = false
					let allTemp = res.data.data
					const s = new Set();
					allTemp.forEach(item => {
						item.data.forEach((v) => {
							s.add(v.s)
							s.add(v.e)
						});
					})
					
					let hours = Array.from(s);
					hours = hours.sort((a, b) => {
						return Number(new Date('2025/01/01 ' + a + ':00').getTime() - new Date('2025/01/01 ' + b + ':00').getTime())
					})
					let current = new Date().getTime()
					allTemp.forEach(item => {
						
						let scheduling = []
						
						item.data.forEach((v) => {
							if(current > this.timeToTemp(`${this.day} ${v.s}:00`) ){
								v.v = 0
							}
							let s_row = hours.indexOf(v.s) + 1
							let e_row = hours.indexOf(v.e) + 1
							v.s_row = s_row
							v.e_row = e_row
							scheduling.push(v)
						});
						
						item.data = scheduling
						
					})
					this.appointmentList = allTemp
					this.timeList = hours;
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	
		.time-text{
			font-size: 13px;
			color: #ff962c;
			padding: 10px 0;
		}
	
		.wrapper {
			padding: 30px 30px 0 0;
		}
	
		.scroll-box {
			max-width: calc(100vw - 150px);
		}
	
		.time {
			flex-shrink: 0;
			width: 50px;
			height: 40px;
			text-align: center;
			font-size: 12px;
			font-weight: 600;
			color: #333;
			padding-right: 10px;
			position: relative;
			
			&::before {
				display: block;
				content: '';
				position: absolute;
				width: 10px;
				height: 1px;
				background-color: #333;
				right: 0px;
				top: -1px;
			}
	
			text {
				position: absolute;
				top: -0.5em;
			}
		}
	
		.left-time {
			margin-top: 40px ;
		}
	
		.title {
			width: 80px;
			height: 40px;
			text-align: center;
			color: #666;
			font-size: 13px;
			font-weight: 600;
		}
	.scheduling-wrap {
			display: grid;
			grid-template-columns: 40px;
			background-color: #f7f7f7;
			margin-right: 2px;
		}
		.apt-box {
			font-size: 13px;
			color: #fff;
	
			.apt-wrap {
				width: 80px;
				display: flex;
				align-items: center;
				justify-content: center;
				border: 1px solid #fff;
				border-radius: 4px;
				background-color: #08C243;
			}
	
			.sale {
				background-color: #d6d6d6 !important;
			}
	
			.check {
				color: #fff;
				background-color: #ff962c !important;
			}
		}
	
.p-btn{
		@include plain-btn(120px,52px,20px);
	}
	.tips{
		font-size: 13px;
	}
</style>
